// extracted by mini-css-extract-plugin
export default {"showcase":"TermsAndCondition_showcase__31lMm","overlay":"TermsAndCondition_overlay__DnrD6","Margin2":"TermsAndCondition_Margin2__cGkwQ","H3":"TermsAndCondition_H3__OXK9C"};